import { combineReducers } from 'redux';
import AuthReducer from './gl_auth_reducer/reducer';
import TranslationReducer from './gl_translations_reducer/reducer';
import NavigationReducer from './gl_navigation_reducer/reducer';
import ModalReducer from './gl_modal_reducer/reducer';
import ResetPasswordReducer from './resetPassword_reducer/reducer';
import RegisterReducer from './register_reducer/reducer';
import RegistrationListReducer from './registration_list_reducer/reducer';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import RegistrationDetailReducer from './registration_detail_reducer/reducer';
import ApplicantListReducer from './applicant_list_reducer/reducer';
import NotificationReducer from './notification_reducer/reducer';
import VatReturnReducer from './vatReturn_list_reducer/reducer';
import VatReturnDetailReducer from './vatReturn_detail_reducer/reducer';
import PaymentListReducer from './payment_list_reducer/reducer';
import MessageOutgoingReducer from './message_outgoing_reducer/reducer';
import MessageIncomingReducer from './message_incoming_reducer/reducer';
import RegistrationReceivedReducer from './registration_received_reducer/reducer';
import RequestReducer from './request_reducer/reducer';
import VatReturnReminderReducer from './vatReturn_reminders_reducer/reducer';
import PaymentRemindersReducer from './payment_reminders_reducer/reducer';
import VatReturnsReceivedListReducer from './vatreturns_received_list_reducer/reducer';
import RemindersMsconReceivedListReducer from './reminders_mscon_received_list_reducer/reducer';
import RemindersMsidReceivedListReducer from './reminders_msid_received_list_reducer/reducer';
import PaymentsReceivedListReducer from './payments_received_list_reducer/reducer';
import ReimbursementsReceivedListReducer from './reimbursements_received_list_reducer/reducer';
import ReimbursementsListReducer from './reimbursements_list_reducer/reducer';
import AdminDashboardReducer from './admin_dashboard_reducer/reducer';
import PaymentCentralBankReducer from './payment_central_bank_reducer/reducer';
import VatRateReducer from './vat_rate_reducer/reducer';

export enum ReducerKeys {
  AUTH_REDUCER = 'AuthReducer',
  TRANSL_REDUCER = 'TranslationReducer',
  NAVIGATION_REDUCER = 'NavigationReducer',
  MODAL_REDUCER = 'ModalReducer',
  RESET_PASSOWRD_REDUCER = 'ResetPasswordReducer',
  REGISTER_REDUCER = 'RegisterReducer',
  REGISTRATION_LIST_REDUCER = 'RegistrationListReducer',
  REGISTRATION_DETAIL_REDUCER = 'RegistrationDetailReducer',
  APPLICANT_LIST_REDUCER = 'ApplicantListReducer',
  NOTIFICATION_REDUCER = 'NotificationReducer',
  VATRETURN_LIST_REDUCER = 'VatReturnListReducer',
  VATRETURN_DETAIL_REDUCER = 'VatReturnDetailReducer',
  PAYMENT_LIST_REDUCER = 'PaymentListReducer',
  CENTRAL_BANK_PAYMENT_LIST_REDUCER = 'CentralBankPaymentListReducer',
  MESSAGE_OUTGOING_REDUCER = 'MessageOutgoingReducer',
  MESSAGE_INCOMING_REDUCER = 'MessageIncomingReducer',
  REGISTRATION_RECEIVED_REDUCER = 'RegistrationReceivedReducer',
  REQUEST_REDUCER = 'RequestReducer',
  VATRETURN_REMINDER_REDUCER = 'VatReturnReminderReducer',
  PAYMENT_REMINDER_REDUCER = 'PaymentReminderReducer',
  VATRETURNS_RECEIVED_LIST_REDUCER = 'VatReturnsReceivedListReducer',
  REMINDERS_MSCON_RECEIVED_LIST_REDUCER = 'RemindersMsconReceivedListReducer',
  REMINDERS_MSID_RECEIVED_LIST_REDUCER = 'RemindersMsidReceivedListReducer',
  PAYMENTS_RECEIVED_LIST_REDUCER = 'PaymentsReceivedListReducer',
  REIMBURSEMENTS_RECEIVED_LIST_REDUCER = 'ReimbursementsReceivedListReducer',
  REIMBURSEMENTS_LIST_REDUCER = 'ReimbursementsListReducer',
  ADMIN_DASHBOARD_REDUCER = 'AdminDashboardReducer',
  VAT_RATE_REDUCER = 'VatRateReducer',
}

const authPersistConfig = {
  key: ReducerKeys.AUTH_REDUCER,
  storage: storage,
  blacklist: ['status'],
};

const navigationPersistConfig = {
  key: ReducerKeys.NAVIGATION_REDUCER,
  storage: storage,
};

const rootReducer = combineReducers({
  // global
  [ReducerKeys.AUTH_REDUCER]: persistReducer(authPersistConfig, AuthReducer),
  [ReducerKeys.TRANSL_REDUCER]: TranslationReducer,
  [ReducerKeys.NAVIGATION_REDUCER]: persistReducer(
    navigationPersistConfig,
    NavigationReducer
  ),
  [ReducerKeys.MODAL_REDUCER]: ModalReducer,

  // local
  [ReducerKeys.RESET_PASSOWRD_REDUCER]: ResetPasswordReducer,
  [ReducerKeys.REGISTER_REDUCER]: RegisterReducer,
  [ReducerKeys.REGISTRATION_LIST_REDUCER]: RegistrationListReducer,
  [ReducerKeys.REGISTRATION_DETAIL_REDUCER]: RegistrationDetailReducer,
  [ReducerKeys.APPLICANT_LIST_REDUCER]: ApplicantListReducer,
  [ReducerKeys.NOTIFICATION_REDUCER]: NotificationReducer,
  [ReducerKeys.VATRETURN_LIST_REDUCER]: VatReturnReducer,
  [ReducerKeys.VATRETURN_DETAIL_REDUCER]: VatReturnDetailReducer,
  [ReducerKeys.PAYMENT_LIST_REDUCER]: PaymentListReducer,
  [ReducerKeys.MESSAGE_OUTGOING_REDUCER]: MessageOutgoingReducer,
  [ReducerKeys.MESSAGE_INCOMING_REDUCER]: MessageIncomingReducer,
  [ReducerKeys.REGISTRATION_RECEIVED_REDUCER]: RegistrationReceivedReducer,
  [ReducerKeys.REQUEST_REDUCER]: RequestReducer,
  [ReducerKeys.VATRETURN_REMINDER_REDUCER]: VatReturnReminderReducer,
  [ReducerKeys.PAYMENT_REMINDER_REDUCER]: PaymentRemindersReducer,
  [ReducerKeys.VATRETURNS_RECEIVED_LIST_REDUCER]: VatReturnsReceivedListReducer,
  [ReducerKeys.REMINDERS_MSCON_RECEIVED_LIST_REDUCER]:
    RemindersMsconReceivedListReducer,
  [ReducerKeys.REMINDERS_MSID_RECEIVED_LIST_REDUCER]:
    RemindersMsidReceivedListReducer,
  [ReducerKeys.PAYMENTS_RECEIVED_LIST_REDUCER]: PaymentsReceivedListReducer,
  [ReducerKeys.REIMBURSEMENTS_RECEIVED_LIST_REDUCER]:
    ReimbursementsReceivedListReducer,
  [ReducerKeys.REIMBURSEMENTS_LIST_REDUCER]: ReimbursementsListReducer,
  [ReducerKeys.ADMIN_DASHBOARD_REDUCER]: AdminDashboardReducer,
  [ReducerKeys.CENTRAL_BANK_PAYMENT_LIST_REDUCER]: PaymentCentralBankReducer,
  [ReducerKeys.VAT_RATE_REDUCER]: VatRateReducer,
});

export default rootReducer;
